import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  DeleteAuthorizations,
  FetchCptcodes,
  FetchCptcodesforauth,
  GETAuthorizations,
  PatchAuthorizations,
  PostAuthorizations,
} from "../../../../../api/helper";
import { ShowToast } from "../../../../../helpers/ToastService";
import { Box, Modal } from "@mui/material";
import Inputbox from "../../../../Components/Inputbox";
import DeleteModal from "../../../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  Auth: Yup.string().required("Authorization number is required."),
  ServiceCode: Yup.string().required("Service code is required."),
  ServiceDescription: Yup.string().required("Service description is required."),
  AuthorizationStatus: Yup.string().required(
    "Authorization status is required."
  ),
  DateApproved: Yup.string().required("Date approved is required."),
  EffectiveStart: Yup.string().required("Effective start date is required."),
  EffectiveEnd: Yup.date()
    .nullable()
    .required("Effective end date is required."),
  UnitsPer: Yup.number()
    .positive("Units per must be a positive number.")
    .required("Units per is required."),
  UnitOfMeasure: Yup.string().required("Unit of measure is required."),
  UnitRate: Yup.string().required("Unit rate is required."),
  MaxUnits: Yup.number()
    .positive("Max units must be a positive number.")
    .required("Max units is required."),
  AmountApproved: Yup.string().required("Amount approved is required."),
});

const AuthorizationsScreen = ({ info }) => {
  const [authorization, setauthorization] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [modalopen, setmodalopen] = useState(false);
  const [selectedAuthorization, setSelectedAuthorization] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [cptCodes, setcptCodes] = useState({
    data: [],
    pagination: { totalPages: 0 },
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCPT, setselectedCPT] = useState("");
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);
  const [modal, setmodal] = useState(false);
  const pageSize = 50;
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    if (modalopen) {
      if (selectedAuthorization) {
        reset(selectedAuthorization);
      } else {
        reset({});
      }
    }
  }, [modalopen, selectedAuthorization]);
  const handleEdit = (authData) => {
    setSelectedAuthorization(authData);
    setIsEditMode(true);
    setmodalopen(true);
  };

  const handleAddNew = () => {
    setSelectedAuthorization(null);
    setIsEditMode(false);
    setmodalopen(true);

    setTimeout(() => {
      reset({});
    }, 0);
  };

  const handleCloseModal = () => {
    setmodalopen(false);
    reset({});
  };
  const onSubmit = async (data) => {
    // console.log("Form Data:", data);
    data.agencyId = profiledata?._id;
    data.patientId = info?._id;
    console.log(data,"datata=========")
    try {
      let response;
      if (isEditMode && selectedAuthorization) {
        response = await PatchAuthorizations(selectedAuthorization._id, data);
      } else {
        response = await PostAuthorizations(data);
      }

      ShowToast(response?.data?.message);
      console.log(response?.data?.data);
      getinsurencedetails();
      setmodalopen(false);
      reset();
    } catch (error) {
      console.log(error);
    }
  };

  const getinsurencedetails = async () => {
    try {
      const response = await GETAuthorizations(profiledata?._id,info?._id);
      // console.log(response?.data?.data?.data, "hello=====");
      setauthorization(response?.data?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const Getcptcodes = async (search = "", page = 1) => {
    try {
      const response = await FetchCptcodesforauth(search, page, pageSize);
      if (response?.data?.data) {
        setcptCodes({
          data: response.data.data,
          pagination: response.data.data.pagination || { totalPages: 0 },
        });
      } else {
        console.error("Unexpected API response structure");
        setcptCodes({ data: [], pagination: { totalPages: 0 } });
      }
      // setcptCodes(newCodes);
    } catch (error) {
      console.log(error);
      setcptCodes({ data: [], pagination: { totalPages: 0 } });
    }
  };
  useEffect(() => {
    getinsurencedetails();
    Getcptcodes(1);
  }, []);
  const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);

    try {
      const response = await DeleteAuthorizations(deleteId);
      ShowToast(response?.data?.message);
      getinsurencedetails();
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    Getcptcodes(e.target.value);
  };
  const handelChange = (Service) => {
    console.log(Service, "Service=-=-=-=-=");
    setselectedCPT(Service?.codeAndDefinition);
    setValue("ServiceCode", Service?.codeAndDefinition || "");
    setValue("ServiceDescription", Service?.procDescription || "");
    trigger("ServiceCode");
    setmodal(false);
    setCurrentPage(1);
    setSearchTerm("");
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    Getcptcodes(searchTerm, page);
  };
  return (
    <>
      <Modal
        open={modal}
        onClose={() => {
          setmodal(false);
        }}
        aria-labelledby="modal-title"
      >
        <Box sx={modalinsuranceStyle}>
          <div>
            <Inputbox
              label={"Search Cpt Codes"}
              placeholder={"Type to search..."}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div style={{ marginTop: 20 }}>
              {cptCodes?.data?.data?.length > 0 ? (
                cptCodes?.data?.data?.map((cpt) => {
                  return (
                    <div
                      key={cpt._id}
                      className="diagnosis-item"
                      onClick={() => handelChange(cpt)}
                    >
                      <div>
                        <strong>Code:</strong> {cpt.procCode}
                      </div>
                      <div>
                        <strong>Description:</strong> {cpt.procDescription}
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No Cpt Codes available.</p>
              )}
            </div>

            <div
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* Previous Button */}
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  margin: "5px",
                  padding: "10px 20px",
                  backgroundColor: currentPage === 1 ? "#ccc" : "#007BFF",
                  color: "#fff",
                  border: "1px solid #007BFF",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                }}
              >
                Previous
              </button>

              <span
                style={{
                  margin: "5px",
                  padding: "10px 20px",
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #007BFF",
                }}
              >
                {currentPage} of {cptCodes?.data?.totalPages}
              </span>

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === cptCodes?.pagination?.totalPages}
                style={{
                  margin: "5px",
                  padding: "10px 20px",
                  backgroundColor:
                    currentPage === cptCodes?.pagination?.totalPages
                      ? "#ccc"
                      : "#007BFF",
                  color: "#fff",
                  border: "1px solid #007BFF",
                  cursor:
                    currentPage === cptCodes?.pagination?.totalPages
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                Next
              </button>
            </div>
          </div>
        </Box>
      </Modal>
      <button className="add-button_insuranceDetails" onClick={handleAddNew}>
        Add New Authorization
      </button>
      {modalopen && (
        <div
          style={{
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            position: "fixed",
            zIndex: 1000,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal_insuranceDetails">
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  width: 30,
                  cursor: "pointer",
                }}
                onClick={handleCloseModal}
              >
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTkP8S8v6oIxwDrJfdNdFU7FvVNZCcK025zZg&s"
                  style={{ height: 20, width: 20 }}
                />
              </div>
            </div>
            <h2>
              {isEditMode
                ? "Edit Authorization Details"
                : "Authorization Details"}
            </h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails">
                  <label htmlFor="auth-number">Auth # [Box 23]</label>
                  <input
                    type="text"
                    id="auth-number"
                    placeholder="Enter authorization number"
                    {...register("Auth")}
                  />
                  {errors.Auth && (
                    <p className="error">{errors.Auth.message}</p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="service-code">Service Code</label>
                  <input
                    type="hidden"
                    {...register("ServiceCode")}
                    value={selectedCPT}
                  />
                  <div
                    onClick={() => setmodal(true)}
                    style={{
                      borderWidth: 1,
                      height: "43px",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    className="form-column_insuranceDetails_div"
                  >
                    {selectedCPT ? (
                      <div style={{ textAlign: "left" }}>{selectedCPT}</div>
                    ) : (
                      <div style={{ textAlign: "left", color: "grey" }}>
                        Select Service Code
                      </div>
                    )}
                  </div>
                  {errors.ServiceCode && (
                    <p className="error">{errors.ServiceCode.message}</p>
                  )}
                </div>

                <div className="form-column_insuranceDetails">
                  <label htmlFor="service-description">
                    Service Description
                  </label>
                  <input
                    type="text"
                    id="service-description"
                    placeholder="Enter service description"
                    {...register("ServiceDescription")}
                  />
                  {errors.ServiceDescription && (
                    <p className="error">{errors.ServiceDescription.message}</p>
                  )}
                </div>
              </div>
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails">
                  <label htmlFor="authorization-status">
                    Authorization Status
                  </label>
                  <select
                    id="authorization-status"
                    {...register("AuthorizationStatus")}
                  >
                    <option value="Approved">Approved</option>
                    <option value="Pending">Pending</option>
                    <option value="Denied">Denied</option>
                  </select>
                  {errors.AuthorizationStatus && (
                    <p className="error">
                      {errors.AuthorizationStatus.message}
                    </p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="date-approved">Date Approved</label>
                  <input
                    type="date"
                    id="date-approved"
                    {...register("DateApproved")}
                  />
                  {errors.DateApproved && (
                    <p className="error">{errors.DateApproved.message}</p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="effective-start">Effective Start</label>
                  <input
                    type="date"
                    id="effective-start"
                    {...register("EffectiveStart")}
                  />
                  {errors.EffectiveStart && (
                    <p className="error">{errors.EffectiveStart.message}</p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="effective-end">Effective End</label>
                  <input
                    type="date"
                    id="effective-end"
                    {...register("EffectiveEnd")}
                  />
                  {errors.EffectiveEnd && (
                    <p className="error">{errors.EffectiveEnd.message}</p>
                  )}
                </div>
              </div>
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails">
                  <label htmlFor="units-per">Units Per</label>
                  <input
                    type="text"
                    id="units-per"
                    placeholder="e.g., 1.00"
                    {...register("UnitsPer")}
                  />
                  {errors.UnitsPer && (
                    <p className="error">{errors.UnitsPer.message}</p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="unit-of-measure">Unit of Measure</label>
                  <select id="unit-of-measure" {...register("UnitOfMeasure")}>
                    <option value="Quarter-Hour">Quarter-Hour</option>
                    <option value="Hour">Hour</option>
                    <option value="Session">Session</option>
                  </select>
                  {errors.UnitOfMeasure && (
                    <p className="error">{errors.UnitOfMeasure.message}</p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="unit-rate">Unit Rate</label>
                  <input
                    type="text"
                    id="unit-rate"
                    placeholder="e.g., $2,440.65"
                    {...register("UnitRate")}
                  />
                  {errors.UnitRate && (
                    <p className="error">{errors.UnitRate.message}</p>
                  )}
                </div>
              </div>
              <div className="form-row_insuranceDetails">
                <div className="form-column_insuranceDetails">
                  <label htmlFor="max-units">Max Units</label>
                  <input
                    type="text"
                    id="max-units"
                    placeholder="e.g., 12"
                    {...register("MaxUnits")}
                  />
                  {errors.MaxUnits && (
                    <p className="error">{errors.MaxUnits.message}</p>
                  )}
                </div>
                <div className="form-column_insuranceDetails">
                  <label htmlFor="amount-approved">Amount Approved</label>
                  <input
                    type="text"
                    id="amount-approved"
                    placeholder="e.g., $29,287.80"
                    {...register("AmountApproved")}
                  />
                  {errors.AmountApproved && (
                    <p className="error">{errors.AmountApproved.message}</p>
                  )}
                </div>
              </div>
              <button type="submit" onclick="saveAuthorization()">
                Save Authorization
              </button>
            </form>
          </div>
        </div>
      )}
      <div className="authorization-list">
        <h2>Authorization List</h2>
        <table>
          <thead>
            <tr>
              <th>Auth #</th>
              <th>Service Code</th>
              <th>Status</th>
              <th>Effective Start</th>
              <th>Effective End</th>
              <th>Units Per</th>
              <th>Unit Rate</th>
              <th>Max Units</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody id="insurance-table-body">
            {authorization.map((item) => (
              <tr key={item._id}>
                <td>{item.Auth}</td>
                <td>{item.ServiceCode}</td>
                <td>{item.AuthorizationStatus}</td>
                <td>{item.EffectiveStart}</td>
                <td>{item.EffectiveEnd}</td>
                <td>{item.UnitsPer}</td>
                <td>{item.UnitRate}</td>
                <td>{item.MaxUnits}</td>
                <td>
                  <button
                    className="check-eligibility_insuranceDetails"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </button>
                  <button
                    style={{ marginLeft: 10,backgroundColor:'red' }}
                    onClick={() => handleRemove(item._id)}
                      className="check-eligibility_insuranceDetails"

                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {confirmdeletemodal && (
        <DeleteModal
          name="Authorization"
          onClose={() => setconfirmdeletemodal(false)}
          onConfirm={confirmDelete}
        />
      )}
    </>
  );
};
const modalinsuranceStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
  outline: "none",
  overflowY: "auto",
};

export default AuthorizationsScreen;
